import palette from '@lib/core/src/theme/palette';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Chip, SxProps, Typography } from '@mui/material';

import { TemplateCardContainer, TemplateCardIconContainer } from './AgentTemplateStyles';

type TemplateCardProps = {
  id?: string;
  icon: string | React.ReactNode;
  name: string;
  description: string;
  tags?: string[];
  onClick?: () => void;
  isSelected?: boolean;
  showTags?: boolean;
  containerStyle?: SxProps;
};

export const TemplateCard = ({
  icon = '\u{1F4D3}',
  name,
  description,
  tags,
  containerStyle,
  showTags = true,
  isSelected = false,
  onClick
}: TemplateCardProps) => (
  <TemplateCardContainer sx={containerStyle} onClick={onClick}>
    <TemplateCardIconContainer>{icon}</TemplateCardIconContainer>
    <Box sx={{ flex: 1 }}>
      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: palette.black }}>
        {name}
      </Typography>
      <Typography sx={{ fontSize: '11px', fontWeight: 500, color: palette.grey[400] }}>
        {description}
      </Typography>
      {showTags && (
        <Box sx={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          {tags?.map(tag => (
            <Chip
              key={tag}
              label={tag}
              sx={{
                fontSize: '11px',
                fontWeight: 500,
                height: 'unset',
                paddingTop: '3px',
                paddingBottom: '3px',
                color: palette.grey[500],
                background: palette.grey[800]
              }}
            />
          ))}
        </Box>
      )}
    </Box>
    {isSelected && (
      <Box sx={{ alignContent: 'center' }}>
        <CheckIcon sx={{ color: palette.blue[100], fontSize: '0.8rem' }} />
      </Box>
    )}
  </TemplateCardContainer>
);
